import { CompanyShowType } from '@api';
import {
  CompanyAnchor,
  formatDate,
  PersonAnchor,
  ShowTableCell,
  StatusBadge,
} from '@common';
import { DataTableColumn } from 'mantine-datatable';
import { useTranslation } from 'react-i18next';

export type UseCompanyShowsColumnsReturnType = {
  columns: DataTableColumn<CompanyShowType>[];
};

export const useCompanyShowsColumns = (): UseCompanyShowsColumnsReturnType => {
  const { t } = useTranslation('companyDetailsShows');

  const noDataPlaceholder = t('NO_DATA_PLACEHOLDER', { ns: 'common' });

  return {
    columns: [
      {
        accessor: 'showDate',
        title: t('COMPANY_SHOWS.TABLE.SHOW_DATE'),
        sortable: true,
        render: (record) => formatDate(record.showDate),
      },
      {
        accessor: 'showWithTour',
        title: t('COMPANY_SHOWS.TABLE.SHOW'),
        render: (record) => <ShowTableCell show={record.showWithTour} />,
      },
      {
        accessor: 'dealType',
        title: t('COMPANY_SHOWS.TABLE.DEAL_TYPE'),
        render: (record) => record.dealType ?? noDataPlaceholder,
      },
      {
        accessor: 'production',
        title: t('COMPANY_SHOWS.TABLE.PRODUCTION'),
        render: (record) => record.production ?? noDataPlaceholder,
      },
      {
        accessor: 'agent.name',
        title: t('COMPANY_SHOWS.TABLE.AGENT'),
        render: (record) =>
          record.agent ? (
            <PersonAnchor person={record.agent} />
          ) : (
            noDataPlaceholder
          ),
      },
      {
        accessor: 'tourLead.name',
        title: t('COMPANY_SHOWS.TABLE.TOUR_LEAD'),
        render: (record) =>
          record.tourLead ? (
            <CompanyAnchor company={record.tourLead} />
          ) : (
            noDataPlaceholder
          ),
      },
      {
        accessor: 'tourCoPro.name',
        title: t('COMPANY_SHOWS.TABLE.TOUR_CO_PRO'),
        render: (record) =>
          record.tourCoPro ? (
            <CompanyAnchor company={record.tourCoPro} />
          ) : (
            noDataPlaceholder
          ),
      },
      {
        accessor: 'coPro.name',
        title: t('COMPANY_SHOWS.TABLE.CO_PRO'),
        render: (record) =>
          record.coPro ? (
            <CompanyAnchor company={record.coPro} />
          ) : (
            noDataPlaceholder
          ),
      },
      {
        accessor: 'status',
        title: t('COMPANY_SHOWS.TABLE.STATUS'),
        render: (record) => <StatusBadge status={record.status} />,
      },
    ],
  };
};
